__turbopack_context__.v({
  "blinker": "Logo-module__l_qe3G__blinker",
  "logo": "Logo-module__l_qe3G__logo",
  "max": "Logo-module__l_qe3G__max",
});
